import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getLocalized, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import { createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import {
	deleteBOQTemplateGroups,
	listBOQTemplateGroups,
	readBOQTemplateGroup
} from "../../redux/actions/table/superadmin/boq_template_groups";
import BOQTemplateGroupsFlyout from "../../flyouts/superadmin/boq_template_groups/BOQTemplateGroupsFlyout";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_boq_template_groups"],
	application_language_id: state.auth.language_id,
}))
class BOQTemplateGroups extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_boq_template_group && setPlusActions([{
			title: "Add BOQ template group",
			onClick: () => setTableParams('superadmin_boq_template_groups', {
				add_boq_template_group_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readBOQTemplateGroup(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		const columns = [
			{
				key: "id",
				name: "ID",
				width: 60,
				sortable: false
			},
			{
				key: "name",
				name: "Name",
				value: name => getLocalized(name, application_language_id)
			},
		];

		const singleActions = (boq_template_group_id) => {
			return [
				<Tooltip text="Delete selected BOQ template group" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected BOQ template group?\n\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteBOQTemplateGroups([boq_template_group_id]).then(() => {
												hideAlertbox();

												setNotification("The selected BOQ template group has been deleted.");
												listBOQTemplateGroups();

												setTableParams('superadmin_boq_template_groups', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (boq_template_groups_ids) => [
			<Tooltip text="Delete selected BOQ template groups" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these BOQ template groups?\n\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteBOQTemplateGroups(boq_template_groups_ids).then(() => {
											hideAlertbox();

											setNotification("The selected BOQ template groups have been deleted.");
											listBOQTemplateGroups();

											setTableParams('superadmin_boq_template_groups', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<BOQTemplateGroupsFlyout
				data={this.state.preview}
				readAction={boq_template_group_id => {
					return new Promise(resolve => {
						readBOQTemplateGroup(getURLParam('id') || boq_template_group_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listBOQTemplateGroups}
				name="superadmin_boq_template_groups"
				groupActions={superadmin.delete_boq_template_group && groupActions}
				singleActions={superadmin.delete_boq_template_group && singleActions}
				title={__("modules.submodules.title.boq-template-groups")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default BOQTemplateGroups;
